import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Aksaray Mahallesi Halı Yıkama",
    path: "/fatih/aksaray-hali-yikama",
    description:
      "Aksaray Mahallesi’nde halılarınız hijyenik şekilde yıkanır, tam otomatik makinelerle temizlenip evinize teslim edilir."
  },
  {
    label: "Fındıkzade Halı Yıkama",
    path: "/fatih/findikzade-hali-yikama",
    description:
      "Fındıkzade semtinde halılarınızı antibakteriyel ürünlerle temizliyor, hızlı teslimatla memnuniyet garantisi sunuyoruz."
  },
  {
    label: "Çapa Mahallesi Halı Yıkama",
    path: "/fatih/capa-hali-yikama",
    description:
      "Çapa Mahallesi’nde halılarınız profesyonel makinelerle zarar görmeden yıkanır ve zamanında teslim edilir."
  },
  {
    label: "Samatya Halı Yıkama",
    path: "/fatih/samatya-hali-yikama",
    description:
      "Samatya bölgesine özel servis araçlarımızla halılarınızı evinizden alıyor, özenle temizleyerek geri getiriyoruz."
  },
  {
    label: "Kocamustafapaşa Mahallesi Halı Yıkama",
    path: "/fatih/kocamustafapasa-hali-yikama",
    description:
      "Kocamustafapaşa Mahallesi’nde çevre dostu ve sağlıklı halı yıkama hizmeti profesyonel ekibimizle sunulmaktadır."
  },
  {
    label: "Balat Halı Yıkama",
    path: "/fatih/balat-hali-yikama",
    description:
      "Tarihi Balat bölgesine özel özenli halı yıkama hizmetimizle, el dokuma ve değerli halılarınız güvenle temizlenir."
  },
  {
    label: "Hırka-i Şerif Mahallesi Halı Yıkama",
    path: "/fatih/hirka-i-serif-hali-yikama",
    description:
      "Hırka-i Şerif Mahallesi’nde bireysel ve ticari müşterilere uygun fiyatlı ve kaliteli halı yıkama hizmeti veriyoruz."
  }
];

const FatihSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">FATİH SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FatihSidebar;
